import React from "react";

const EditarTarjeta = (props) => {
    return (
        <div>
            <div className="col-md-3">
                <label className="label-secondary">{props.edit.headline}</label>
            </div>
            <div className="col-md-9">
                <button type="button" className="btn btn-link" onClick={props.changeToSelectCard}>Cambiar</button>
            </div>
        </div >
    );
}

export default EditarTarjeta